import React, { useEffect, useState } from 'react'
import { Icon, Button} from '@ds/ui'

interface NavBarProps {
  children: React.ReactNode
  state: {
    view: 'main' | 'keyManagement' | 'restore'
  }
  setState: React.Dispatch<React.SetStateAction<{
    view: 'main' | 'keyManagement' | 'restore'
  }>>
}

export default function NavBar({ 
  children, 
  state,
  setState 
}: NavBarProps) {
  const [pageData, setPageData] = useState({
    vendorName: 'DocuSign',
    appName: 'Loading...',
    revision: 'Loading...'
  })

  const [isLoading, setIsLoading] = useState<boolean>(true)

  useEffect(() => {
    const getLayoutInfo = async () => {
      try {
        const response = await fetch('Admin/Home/GetLayoutInfo')
        const data = await response.json()
        setPageData(prev => ({
          ...prev,
          vendorName: data.userInfo.vendorName,
          appName: data.userInfo.appName,
          revision: data.userInfo.revision
        }))
        setIsLoading(false)
      } catch (error) {
        console.error('Error fetching layout info:', error)
        setIsLoading(false)
      }
    }

    getLayoutInfo()
  }, [])

  return (
    <div className="navbar-container flex flex-col">
      {(state.view === 'keyManagement' || state.view === 'restore') && (
      <div style={{
        display: 'flex',
        position: 'fixed',
        paddingTop: '9rem',
        paddingLeft: '0',
        justifyContent: 'space-between',
        alignItems: 'left',
        backgroundColor: '#fff',
        width: '100%'
      }}>
            <Button 
              onClick={() => setState(prev => ({ ...prev, view: 'main' }))} 
              accessibilityText="Back to main view"
              icon="arrow-left"
              size="small"
            />
        </div>
      )}


      <main className="flex-1">
        {children}
      </main>
    </div>
  )
}